import React, { createContext, useState } from 'react';

const initialState = {
    hasAcceptedTerms: null, // null = no verificado, true/false = verificado
    isChecking: false
};

const TermsContext = createContext(initialState);

export const TermsProvider = ({ children }) => {
    const [hasAcceptedTerms, setHasAcceptedTerms] = useState(null);
    const [isChecking, setIsChecking] = useState(false);

    return (
        <TermsContext.Provider
            value={{
                hasAcceptedTerms,
                setHasAcceptedTerms,
                isChecking,
                setIsChecking
            }}
        >
            {children}
        </TermsContext.Provider>
    );
};

export default TermsContext;

